/* eslint-disable @typescript-eslint/naming-convention */
import {Type} from 'class-transformer';
import 'reflect-metadata';
import {BlockElement, BlockElementSettings} from './blockElement';
import {AppColorList, AppTypographyList, BlockElementType} from '../enums';
import {BlockAction} from './blockAction';

export class BlockElementButton extends BlockElement {
  type: BlockElementType = 'button';
  text: string = null;

  @Type(() => BlockElementButtonSettings)
  settings?: BlockElementButtonSettings = new BlockElementButtonSettings();

  @Type(() => BlockAction)
  action?: BlockAction = null;
}

export class BlockElementButtonSettings extends BlockElementSettings {
  background?: AppColorList = 'primary';
  color?: AppColorList = 'white';
  typography?: AppTypographyList = 'link';
}
